"use strict";
var r, i;
function u() {
  return i || (i = 1, r = Number.isNaN || function(e) {
    return e !== e;
  }), r;
}
export {
  u as __require
};
//# sourceMappingURL=index.es401.js.map
